import { jsxs, jsx } from 'react/jsx-runtime';
import { getDataGridUtilityClass } from '@mui/x-data-grid-premium';
import classnames from 'classnames';
import { Skeleton } from '@cognite/cogs-core';

var SkeletonRow = function SkeletonRow(_ref) {
  var containerWidth = _ref.containerWidth,
    renderedColumns = _ref.renderedColumns,
    style = _ref.style;
  var lastColumnWidth = containerWidth - renderedColumns.reduce(function (a, cur) {
    return a + (cur.width || 0);
  }, 0);
  return jsxs("div", {
    role: "row",
    className: classnames('cogs-lab', 'cogs-skeleton-row', getDataGridUtilityClass('row')),
    style: style,
    children: [renderedColumns.map(function (_ref2) {
      var width = _ref2.width,
        field = _ref2.field;
      return jsx("div", {
        className: classnames('cogs-lab', 'cogs-skeleton-cell', getDataGridUtilityClass('cell'), getDataGridUtilityClass('cellSkeleton'), getDataGridUtilityClass('withBorderColor')),
        style: {
          width: width
        },
        children: jsx(Skeleton.Rectangle, {
          width: "".concat(width, "px")
        })
      }, field);
    }), lastColumnWidth > 0 && jsx("div", {
      className: classnames('cogs-lab', getDataGridUtilityClass('cell'), getDataGridUtilityClass('withBorderColor')),
      style: {
        width: lastColumnWidth
      }
    })]
  });
};

export { SkeletonRow };
